export const TYPES = {
  AbortControllerFactory: Symbol.for('AbortControllerFactory'),
};
